<template>
    <div>
        <el-form :model="data" ref="dynamicForm" class="form-dynamic">
        <div v-for="(parentValue, parentName, parentIndex) in data" :key="parentIndex">
            <el-checkbox v-model="parentValue.active" style="text-transform:capitalize">{{parentName}}</el-checkbox>
            <el-card v-if="parentValue.active" class="time-range-card">
                <el-form-item
                        :prop="parentName + '.value'"
                        :rules="{
                          required: true, message: $t('modal_settings_fieldIsRequired'), trigger: 'blur'
                        }">
                    <el-time-picker
                            size="mini"
                            format="HH:mm"
                            value-format='HH:mm'
                            is-range
                            v-model="parentValue.value"
                            range-separator="-"
                            start-placeholder="Start time"
                            end-placeholder="End time">
                    </el-time-picker>
                </el-form-item>
                <el-button type="text" @click="addBreak(parentName)">+ {{$t('users_tab_workingHours_break')}}</el-button>
                <div class="breaks" v-if="parentValue.breaks.length">
                    <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;">{{$t('users_tab_workingHours_breaks')}}</el-tag>
                    <div class="break" v-for="(item, index) in parentValue.breaks" :key="index">
                        <el-row type="flex" justify="center" align="center" :gutter="20">
                            <el-col>
                                <el-form-item
                                        :prop="'breaks.' + index + '.name'"
                                        :rules="{
                                      required: true, message: $t('modal_settings_fieldIsRequired'), trigger: 'blur'
                                    }">
                                    <el-input v-model="item.name" size="mini" class="break-name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item
                                    :prop="'breaks.' + index + '.value'"
                                    :rules="{
                                      required: true, message: $t('modal_settings_fieldIsRequired'), trigger: 'blur'
                                    }">
                                    <el-time-picker
                                            size="mini"
                                            format="HH:mm"
                                            value-format='HH:mm'
                                            is-range
                                            v-model="item.value"
                                            range-separator="-"
                                            start-placeholder="Start time"
                                            end-placeholder="End time">
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <i class="el-icon-delete" @click="removeBreak(index, parentName)"></i>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-card>
        </div>
        <el-button @click="save()" class="save-button" size="mini" type="primary" plain>{{$t('general_save')}}</el-button>
        </el-form>
    </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: "workingHours",
    data() {
      return {
        data: {
          monday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          tuesday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          wednesday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          thursday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          friday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          saturday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          },
          sunday: {
            active: false,
            value: ['09:00', '18:00'],
            breaks: []
          }
        }
      }
    },
    methods:{
      loadWorkingHours(userId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/users/userWorkingHours?companyUserId=${userId}`)
          .then(response => {
            if (response.data.workingHoursUser) this.data = response.data.workingHoursUser;
            else this.$refs.dynamicForm.resetFields();
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      addBreak(name) {
        if (this.data[name].breaks.length < 5) this.data[name].breaks.push({name: null, value: ['09:00', '10:00']})
      },
      removeBreak(index, name) {
        this.data[name].breaks = this.data[name].breaks.filter((val, i) => i !== index)
      },
      save() {
        this.$refs.dynamicForm.validate((valid) => {
          if (valid) {
            const data = {
              workingHours: this.data
            };
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/users/updateWorkingHours`, data)
              .then(response => {
                this.notification(this.$t('general_success'), response.data.message, "success");
                console.log(response)
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          } else {
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style lang="less" scoped>
    .time-range-card {
        margin: 10px 0;
        .breaks{
            padding: 10px;
            .el-row{
                align-items: center;
            }
            .el-icon-delete{
                cursor: pointer;
                color: #409eff;
            }
        }
        .el-date-editor--timerange{
            width:200px;
        }
    }
    .save-button {
        margin-top:10px;
    }
</style>
